import React from "react";

import LoadingPage from "Dashboard/Components/LoadingPage";
import { companyDashboardTopBarLink } from "Dashboard/EmployerUrls";
import { getAccountById } from "EntitiesApi/Selectors";
import isIntuit from "Intuit/isIntuit";
import { connect } from "react-redux";
import Heartbeat from "ZeroRuby/snippets/heartbeat";

import { Card, CardSection, CardHeader } from "Common/Card";
import DashboardHeader from "Common/DashboardHeader";
import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

import type { State } from "./store";
import type { Account, CompanyProfile } from "Utils/types";

type AccountWithMultipleCompanyProfiles = Account & {
  companyProfiles: Array<CompanyProfile>;
};

type SwitchCompanyProps = {
  isLoaded: boolean;
  account: AccountWithMultipleCompanyProfiles;
  branding: "samsclub" | "square" | "intuit" | "default";
};

type SwitchPageProps = {
  account: AccountWithMultipleCompanyProfiles;
  branding: "samsclub" | "square" | "intuit" | "default";
};

export const SwitchCompanyDumb = ({ isLoaded, account, branding }: SwitchCompanyProps) =>
  isLoaded ? <SwitchPage account={account} branding={branding} /> : <LoadingPage />;

const SwitchPage = ({ account, branding }: SwitchPageProps) => (
  <div>
    <ResponsiveTopBar branding={branding} />

    <Div className="min-h-dvh">
      <Grid componentClass={Card} mt={5} p={0}>
        <DashboardHeader title="Please select the company you want to open" subtitle={`Signed in as: ${account.email}`} />

        {isIntuit() ? <CardHeader>Your QuickBooks Companies</CardHeader> : <CardHeader>Your Companies</CardHeader>}

        <CardSection>
          {account.companyProfiles.map((company) => {
            if (company.idToken) {
              return (
                <p key={company.id}>
                  <a href={companyDashboardTopBarLink(company.idToken.slice(0, 16))}>{company.name}</a>
                </p>
              );
            }
            return null;
          })}
        </CardSection>
      </Grid>
    </Div>
    <Footer />
    <Heartbeat />
  </div>
);

const mapStateToProps = (state: State) => ({
  isLoaded: state.accountId !== "",
  account: state.accountId ? getAccountById(state, state.accountId) : null,
  branding: "default",
});

const withRedux = connect(mapStateToProps);

const SwitchCompany = withRedux(SwitchCompanyDumb);

export default SwitchCompany;
